var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@font-face {\n  font-family: 'Arial-Black';\n\n  src:  url(" + escape(require("../fonts/ArialBlack.ttf")) + ") format('TrueType');\n}\n\n@font-face {\n  font-family: 'BigJohn';\n\n  src:  url(" + escape(require("../fonts/BIGJOHN.otf")) + ") format('OpenType');\n}\n\n@font-face {\n  font-family: 'PingFangSC-Regular';\n\n  src:  url(" + escape(require("../fonts/Ping-Fang-SC-Regular.ttf")) + ") format('TrueType');\n}\n\n@font-face {\n  font-family: 'PingFangSC-Semibold';\n\n  src:  url(" + escape(require("../fonts/PingFang-SC-Semibold.otf")) + ") format('OpenType');\n}\n\n@font-face {\n  font-family: 'PingFangSC-Medium';\n\n  src:  url(" + escape(require("../fonts/PingFang-Medium.ttf")) + ") format('TrueType');\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/bootstrap/css/font.css
// module id = MBIH
// module chunks = 1